import { Tooltip } from '@radix-ui/themes';
import { Info } from 'lucide-react';

/** An ⓘ before a field's label, its help sentence in a tooltip above the drawer (z-50). */
const FieldHint = ({ text }: { text: string }) => (
  <Tooltip content={text} maxWidth="300px" side="top" align="start" className="z-[60]">
    <button
      type="button"
      aria-label={text}
      className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
    >
      <Info className="h-3.5 w-3.5" aria-hidden="true" />
    </button>
  </Tooltip>
);

export default FieldHint;
